const CouponType = () =>
  import(
    /* webpackChunkName: "financial-discount-coupon-type" */ '@/pages/financial/discount/coupon-type/index.vue'
  )
const CreateCouponType = () =>
  import(
    /* webpackChunkName: "financial-discount" */ '@/pages/financial/discount/coupon-type/create.vue'
  )
const EditCouponType = () =>
  import(
    /* webpackChunkName: "financial-discount" */ '@/pages/financial/discount/coupon-type/edit.vue'
  )

export default {
  path: 'coupon-type',
  meta: {
    label: 'couponTypes',
    auth: 'couponType'
  },
  component: {
    name: 'CouponType',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialDiscountCouponType',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: CouponType
    },
    {
      name: 'FinancialCreateDiscountCouponType',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCouponType
    },
    {
      name: 'FinancialEditDiscountCouponType',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCouponType,
      props: true
    }
  ]
}
